import Ten99Reducers from 'Agent/1099s/ducks';
import AccountReducers from 'Agent/Accounts/ducks';
import AgentLicenseReducer from 'Agent/AgentInformation/ducks';
import AgentDocumentationReducers from 'Agent/AgentDocumentation/ducks';
import ClaimsReducers from 'Agent/Claims/ducks';
import CommissionsReducers from 'Agent/Commissions/ducks';
import PolicyReducers from 'Agent/Policies/ducks';
import agentNewsAdministration from 'AgentNewsAdministration/ducks';
import {connectRouter, LocationChangeAction, RouterState} from 'connected-react-router';
import CoreReducers from 'Core/ducks';
import {combineReducers, Reducer} from 'redux';
import UserReducers from 'Users/ducks';
import BulletinsReducer from 'Agent/AgentForms/Bulletins/ducks';
import InteractiveReducer from 'Agent/AgentForms/Interactive/ducks';
import MarketingReducer from 'Agent/AgentForms/Marketing/ducks';
import PreviousOrdersReducer from 'Agent/AgentForms/PreviousOrders/ducks';
import QuotingReducers from 'Quoting/ducks';
import documentUploadReducer from 'Agent/DocumentUploadHistory/ducks';
import quarantineReducer from 'Core/ducks/quarantine';

const reducers = {
  ...Ten99Reducers,
  ...AccountReducers,
  ...BulletinsReducer,
  ...InteractiveReducer,
  ...MarketingReducer,
  ...PreviousOrdersReducer,
  user: combineReducers(UserReducers),
  agentNewsAdministration,
  ...ClaimsReducers,
  ...CommissionsReducers,
  ...AgentDocumentationReducers,
  ...PolicyReducers,
  ...CoreReducers,
  ...AgentLicenseReducer,
  ...QuotingReducers,
  documentUpload: documentUploadReducer,
  quarantine: quarantineReducer,
};

const rootReducer = combineReducers(reducers);
const rootReducerWithHistory = (history: any) => combineReducers({...reducers, router: connectRouter(history)});

export type ReducerState = ReturnType<typeof rootReducer> & {
  router: ReturnType<Reducer<RouterState, LocationChangeAction>>;
};

export default rootReducerWithHistory;
